import React, { useState, useEffect, useCallback, useMemo, useLayoutEffect, useRef } from "react";
import Paper from "@mui/material/Paper";
import TextField from '@mui/material/TextField';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useGridApiRef } from "@mui/x-data-grid-premium";
import DataGrid from "../../shared/DataGrid"
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import CompleteIcon from "@mui/icons-material/CheckCircle";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import DownloadIcon from "@mui/icons-material/Download";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DicomViewerButton from "../../shared/DicomViewerButton"
import RateReviewIcon from "@mui/icons-material/RateReview";
import CircularProgress from "@mui/material/CircularProgress";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import SmsIcon from '@mui/icons-material/Sms';
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import ConstructionIcon from '@mui/icons-material/Construction';
import EmailIcon from '@mui/icons-material/Email';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { Link } from "react-router-dom";
import PdfPreview from "../../shared/PdfPreview";
import Confirmation from "../../../../../common/Comfirmation";
import SendDialog from "../../shared/sendPackage"
import DetailPanelContent from "../../shared/DetailPanelContent"
import TransferDialog from "../../shared/transferStudy"
import AssignStudy from "../../shared/AssignStudy"
import DicomSend from "../../shared/DicomSend";
import { PRIORITIES } from "../../../../../constants/Consult";
import {
  Box,
  Chip,
  Checkbox,
  FormControlLabel,
  MenuItem,
  InputAdornment,
  Popover,
} from "@mui/material";
import {
  DateRangePicker,
  LocalizationProvider
} from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import SellIcon from '@mui/icons-material/Sell';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';
import moment from "moment";
import dayjs from 'dayjs';
import {
  GetStudy,
  GetStudyCount,
  ClaimStudy,
  UnClaimStudy,
  UnRequestStudy,
  Subscribe,
  Unsubscribe,
  CompleteStudy,
  ClearStudy,
  GetToken,
  SendReport,
  UpdateStudyTags,
  GetOrgTags,
  zipApi,
  GetOrgChildren,
  GetOrgConsultUsers
} from "../../../../../api"

let abortSignal, abortCountSignal

const underScoreSort = (a, b) => {
  const e = a.startsWith("_"),
    f = b.startsWith("_");
  return e && !f ? -1 : !e && f ? 1 : 0
}

const debounceTimers = {}
const debounceTime = 1000
const debounceSubTime = debounceTime

const TagCell = ({ tags, availableTags, canDelete, onAdd, onDelete }) => {
  const [anchor, setAnchor] = React.useState(null)
  const label = tags.length === 0 ? '+' : tags.length === 1 ? tags[0].name : `${tags[0].name} +${tags.length - 1}`
  return (
    <>
      <Tooltip title={tags.length > 1 ? tags.map(t => t.name).join(', ') : ''}>
        <Chip
        label={label}
        size="small"
        variant={tags.length ? 'filled' : 'outlined'}
        onClick={e => setAnchor(e.currentTarget)}
        sx={{ maxWidth: 140, '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis' } }}
      />
      </Tooltip>
      <Popover open={Boolean(anchor)} anchorEl={anchor} onClose={() => setAnchor(null)} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
        <Box sx={{ p: 1, minWidth: 180, maxWidth: 280 }}>
          {tags.map(t => (
            <Box key={t.name} sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.5 }}>
              <Chip
                label={t.name}
                size="small"
                onDelete={canDelete(t) ? () => onDelete(t) : undefined}
                sx={{ maxWidth: 220 }}
              />
            </Box>
          ))}
          {availableTags.length > 0 && [
            tags.length > 0 && <Box key="divider" sx={{ borderTop: '1px solid', borderColor: 'divider', my: 0.5 }} />,
            ...availableTags.map(t => (
              <MenuItem key={t} dense onClick={() => { onAdd(t); setAnchor(null) }}>{t}</MenuItem>
            ))
          ]}
        </Box>
      </Popover>
    </>
  )
}

const Teleconsulations = ({ user, view, filter, access, socketStatus }) => {
  const [studies, setStudies] = useState([])
  const [dialogState, setDialogState] = useState({
    open: false,
    studyId: null,
  })
  const [sendDialogState, setSendDialogState] = useState({})
  const [transferDialogState, setTransferDialogState] = useState({})
  const [assignDialogState, setAssignDialogState] = useState({})
  const [dicomSendDialogState, setDicomSendDialogState] = useState({})
  const [apiParams, setApiParams] = useState({ sort: 'sentAt', order: 'desc', limit: '', offset: '' })
  const [loading, setLoading] = useState(false)
  const [rowCount, setRowCount] = useState(0)
  const [pageSize] = useState(50)
  const [search, setSearch] = useState({})
  const [orderedFields, setOrderedFields] = useState()
  const [subs, setSubs] = useState([])
  const [orgTags, setOrgTags] = useState([])
  const [popover, setPopover] = useState()
  const [orgs, setOrgs] = useState()
  const [users, setUsers] = useState()

  const subsRef = useRef()
  subsRef.current = subs

  const org = access.org?.id;

  const [deleteConfirmation, setdeleteConfirmation] = useState({
    open: false,
    text: "",
    studyId: undefined,
  });

  const apiRef = useGridApiRef();
  const [initialState, setInitialState] = React.useState();

  if (access.org.settings?.disablePending && !access.admin) {
    if (filter === 'pending')
      filter = 'pending-available'
    if (!filter)
      filter = 'complete'
  }

  const saveSnapshot = React.useCallback(() => {
    if (apiRef.current?.exportState && localStorage) {
      const currentState = apiRef.current.exportState();
      localStorage.setItem(`DataGridState-${view}-${filter}`, JSON.stringify(currentState));
    }
  }, [apiRef, view, filter])



  useLayoutEffect(() => {
    const oldStateFromLocalStorage = localStorage?.getItem('TeleconsultDataGridState')
    const stateFromLocalStorage = localStorage?.getItem(`DataGridState-${view}-${filter}`) || oldStateFromLocalStorage
    const state = stateFromLocalStorage ? JSON.parse(stateFromLocalStorage) : {
      sorting: { sortModel: [{ field: "sentAt", sort: "desc" }] },
    }
    setInitialState(state)
    if (state.columns?.orderedFields)
      setOrderedFields(state.columns.orderedFields.sort(underScoreSort))

    if (state.pagination?.paginationModel)
      onPageChange(state.pagination.paginationModel)

    // handle refresh and navigating away/refreshing
    window.addEventListener('beforeunload', saveSnapshot);

    return () => {
      // in case of an SPA remove the event-listener
      window.removeEventListener('beforeunload', saveSnapshot);
      saveSnapshot();
    };
  }, [saveSnapshot, view, filter]);

  useEffect(() => {
    GetOrgTags(org).then(setOrgTags).catch(() => setOrgTags([]))
  }, [org])

  const deleteConfirm = () => {
    ClearStudy(deleteConfirmation.studyId).then(() => {
      setStudies((i) => {
        let studies = [...i];
        studies.splice(
          studies.findIndex((x) => x.id === deleteConfirmation.studyId),
          1
        );
        return studies;
      });
      setdeleteConfirmation(
        (i) => (i = { open: false, text: "", studyId: undefined })
      );
    }).catch(error => {
      console.error('Failed to clear study:', error);
    })
  };
  const deleteCancel = () => {
    setdeleteConfirmation(
      (i) => (i = { open: false, text: "", studyId: undefined })
    );
  };
  const clearClick = study => {
    setdeleteConfirmation(
      (i) =>
      (i = {
        open: true,
        text: `Are you sure you want to clear study: 
            ${study.PatientMainDicomTags.PatientName.trim() || ""} 
            ${study.MainDicomTags.StudyDescription.trim() || ""}
            `,
        studyId: study.id,
        error: study.report && 'This study contains a saved report'
      })
    );
  }

  const onSortChange = params => {
    if (rowCount > pageSize)
      setApiParams(x => ({ ...x, sort: (params.length && params[0].field) || '', order: (params.length && params[0].sort) || '' }))
  }
  const onPageChange = params => {
    setApiParams(x => ({ ...x, limit: params.pageSize || '', offset: params.page || '' }))
  }

  const sendOnClose = () => setSendDialogState({})
  const sendOnSend = () => setSendDialogState({})
  const sendPackage = useCallback(params => setSendDialogState({ ...params, open: true, onClose: sendOnClose, onSend: sendOnSend }), [])

  const medDream = StudyInstanceUID => {
    GetToken({ data: StudyInstanceUID }).then(result => {
      let { accessToken } = result
      accessToken && window.open(`https://dream.pacs.corridor.vet/?token=${accessToken}`, '_blank')
    }).catch(e => e)
    return false
  }

  const getStudyCallback = useCallback(() => {
    abortSignal = new AbortController()
    abortCountSignal = new AbortController()
    GetStudy(null, { ...apiParams, view, filter, org, search }, abortSignal.signal).then(result => {
      setStudies(() => result || [])
      setLoading(false)
    }).catch(e => e) // Catch incase of abort
    GetStudyCount({ view, filter, org, search }, abortCountSignal.signal).then(c => setRowCount(c)).catch(e => e)
  }, [apiParams, view, filter, org, search])

  const getStudy = useCallback(() => {
    abortSignal && abortSignal.abort()
    abortCountSignal && abortCountSignal.abort()
    clearTimeout(debounceTimers.refresh)
    debounceTimers.refresh = setTimeout(getStudyCallback, debounceTime)
  }, [getStudyCallback])

  useEffect(() => {
    setLoading(true)
    getStudy()
    return () => {
      abortSignal && abortSignal.abort()
      abortCountSignal && abortCountSignal.abort()
    }
  }, [apiParams, view, filter, org, search, getStudy, socketStatus])

  useEffect(() => {
    const type = (filter && filter.includes('complete') && 'complete') || 'pending'
    Subscribe({ coll: 'studies', type, id: org }, getStudy)
    return () => socketStatus && Unsubscribe({ coll: 'studies', type, id: org })
  }, [filter, org, getStudy, socketStatus])

  const getStudyByIdCallback = useCallback(id => {
    GetStudy(id).then(data => {
      if (data.id) {
        setStudies(studies => {
          const copyStudies = [...studies]
          const i = copyStudies.findIndex((x) => x.id === data.id)
          if (i >= 0) {
            if (!data.sentBy || data.deleted) copyStudies.splice(i, 1)
            else copyStudies[i] = { ...data }
          }
          return copyStudies
        })
      }
    }).catch(e => e)
  }, [])

  const getStudyById = useCallback(id => {
    clearTimeout(debounceTimers[id])
    debounceTimers[id] = setTimeout(() => getStudyByIdCallback(id), debounceSubTime)
  }, [getStudyByIdCallback])

  useEffect(() => {
    if (socketStatus)
      setSubs(subs => {
        const newSubs = []
        for (const study of studies) {
          newSubs.push(study.id)
          if (!subs || !subs.includes(study.id))
            Subscribe({ coll: "studies", type: "update", id: study.id }, resp => getStudyById(resp.id))
        }
        if (subs)
          for (const sub of subs)
            if (!newSubs.includes(sub))
              Unsubscribe({ coll: "studies", type: "update", id: sub })
        return newSubs
      })
    else setSubs([])

  }, [studies, getStudyById, socketStatus])

  useEffect(() => {
    return () => {
      for (const sub of subsRef.current)
        Unsubscribe({ coll: "studies", type: "update", id: sub })
      setSubs([])
    }
  }, [apiParams, view, filter, org, search])

  /* Dynamic Section */
  const respondStudy = (e, completed) => {
    if (completed)
      window.confirm('This study has already been marked complete. Are you sure?') || e.preventDefault()
  }
  const completeStudy = useCallback(id => CompleteStudy(id).then(() => getStudy()).catch(e => e), [getStudy])

  // Transfer dialog
  const transferOnClose = () => setTransferDialogState({})
  const transferOnSend = useCallback((state, orgId) => {
    if (state.studyId && orgId !== org) {
      setStudies(s => {
        const copyStudies = [...s]
        const i = copyStudies.findIndex(x => x.id === state.studyId)
        copyStudies.splice(i, 1)
        return copyStudies
      })
    }
    setTransferDialogState({})

  }, [org])
  const transferStudy = useCallback(params => setTransferDialogState({ ...params, open: true, onClose: transferOnClose, onSend: transferOnSend }), [transferOnSend])

  // Assign dialog
  const assignOnClose = () => setAssignDialogState({})
  const assignOnSend = () => setAssignDialogState({})
  const assignStudy = useCallback(params => setAssignDialogState({ ...params, open: true, onClose: assignOnClose, onSend: assignOnSend }), [])

  // DICOM Send dialog
  const dicomSendOnClose = () => setDicomSendDialogState({})
  const dicomSendOnSend = () => setDicomSendDialogState({})
  const dicomSendStudy = useCallback(params => setDicomSendDialogState({ ...params, open: true, onClose: dicomSendOnClose, onSend: dicomSendOnSend }), [])

  const sendReport = studyId => SendReport(studyId).then(() => alert('Report sent')).catch(error => {
    console.error('Failed to send report:', error);
    alert('Failed to send report. Please try again.');
  })

  const claimStudy = studyId =>
    ClaimStudy(studyId).catch(e => e)

  const hasTransfer = useMemo(() => user.access.filter(e => e.consult || e.transfer).length > 1, [user.access])


  useEffect(() => {
    if (popover?.anchor) {
      if (popover?.filter === 'org') {
        GetOrgChildren(org).then(r => setOrgs(r.length ? r.sort((a, b) => a.name.localeCompare(b.name)) : r))
        return () => setOrgs()
      }
      else if (popover?.filter === 'person') {
        GetOrgConsultUsers(org).then(r => setUsers(r.length ? r.sort((a, b) => a.name.localeCompare(b.name)) : r))
        return () => setUsers()
      }
    }
  }, [popover, org])

  const openPopover = useCallback((event, type) => setPopover({filter: type, anchor: event.currentTarget}), [setPopover])

  /* End Dynamic Section */

  const columnSort = useCallback((a, b) => (orderedFields && orderedFields.indexOf(a.field) - orderedFields.indexOf(b.field)) || 0, [orderedFields])

  const getDetailPanelContent = useCallback(({ row }) => (
    <DetailPanelContent medDream={medDream} setPdfDialogState={setDialogState} org={access.org.id} row={row} showPatientInfo />
  ), [access.org.id, setDialogState])


  const columns = useMemo(() => {

    // eslint-disable-next-line no-unused-vars
    const renderActionsCell = params => {
      const { row } = params;
      const claimed = "claimBy" in row && row.claimBy;
      const completed = row.completeBy ? true : false;
      const claimUser = claimed && (user.id === row.claimBy.id)
      const addendumUser = (row.addendumBy?.id === user.id)
      if (row.requestee && !Array.isArray(row.requestee))
        row.requestee = [row.requestee]
      const requestedUser = row.requestee?.some(e=>e.id===user.id)

      return (
        <>
          <Tooltip title="Download">
            <IconButton
              aria-label="download"
              component={Link}
              to={`${zipApi}studies/${row.id}/zip`}
            >
              <DownloadIcon />
            </IconButton>
          </Tooltip>
          <DicomViewerButton studyId={row.id} disabled={!row.Series?.length} />
          <Tooltip title="Viewer">
            <span>
              <IconButton
                aria-label="view"
                disabled={!row.Series?.length}
                onClick={() => medDream(row.MainDicomTags.StudyInstanceUID)}
              >
                <BrokenImageIcon />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="DICOM Send">
            <span>
              <IconButton
                aria-label="dicom send"
                disabled={!row.Series?.length}
                onClick={() => dicomSendStudy({ studyId: row.id })}
              >
                <CloudUploadIcon />
              </IconButton>
            </span>
          </Tooltip>
          {!claimed && access?.admin && !!access?.org?.users?.length && (
            <Tooltip title="Assign Study">
              <IconButton
                aria-label="assign study"
                color={row.requestee?.length ? 'warning' : 'info'}
                onClick={() => assignStudy({ studyId: row.id })}
              >
                <PersonAddIcon />
              </IconButton>
            </Tooltip>
          )}
          {!completed && // requestedUser
            ((claimed && (claimUser || access?.admin)) || (!requestedUser && row.requestee?.length && access?.admin) ? (
              <Tooltip title="Unclaim study">
                <span>
                  <IconButton
                    aria-label="unclaim"
                    color={claimUser ? 'error' : 'warning'}
                    onClick={() => (claimUser ? UnClaimStudy : UnRequestStudy)(row.id).catch(e => e)}
                  >
                    <RemoveCircleOutlineIcon />
                  </IconButton>
                </span>
              </Tooltip>
            ) : (
              <Tooltip title="Claim study">
                <span>
                  <IconButton
                    disabled={(claimed && (!claimUser || !access?.admin)) || (row.requestee?.length && (!requestedUser))}
                    aria-label="claim"
                    color={row.requestee?.length ? 'info' : 'default'}
                    sx={row.requestee?.length && { "&:disabled": { color: 'rgba(41, 182, 246, 0.25)' } }}
                    onClick={() => claimStudy(row.id)}
                  >
                    <NoteAddIcon />
                  </IconButton>
                </span>
              </Tooltip>
            ))
          }
          <Tooltip title="Respond">
            <span>
              <IconButton
                disabled={!claimUser}
                component={Link}
                to={`/studies/${row.id}/respond`}
                aria-label="respond"
                onClick={(e) => respondStudy(e, completed)}
              >
                <RateReviewIcon />
              </IconButton>
            </span>
          </Tooltip>
          {(completed || access.org?.settings?.viewIncompleteReports) && (
            <Tooltip title="View Report">
              <IconButton
                aria-label="view report"
                onClick={() =>
                  setDialogState({ open: true, studyId: `${row.id}` })
                }
              >
                <PictureAsPdfIcon />
              </IconButton>
            </Tooltip>
          )}
          {!completed && (
            <Tooltip title="Clear">
              <span>
                <IconButton
                  aria-label="clear"
                  onClick={() => clearClick(row)}
                >
                  <SettingsBackupRestoreIcon />
                </IconButton>
              </span>
            </Tooltip>
          )}
          {completed && (
            <Tooltip title="Addendum">
              <span>
                <IconButton
                  aria-label="addendum"
                  component={Link}
                  to={`/studies/${row.id}/addendum`}
                >
                  <SmsIcon />
                </IconButton>
              </span>
            </Tooltip>
          )}
          {row.report && (claimUser || addendumUser) && (
            <Tooltip title="Complete">
              <span>
                <IconButton
                  aria-label="complete"
                  disabled={row.org?.billing?.length && !row.billing?.length}
                  onClick={() => completeStudy(`${row.id}`)}
                >
                  <CompleteIcon />
                </IconButton>
              </span>
            </Tooltip>
          )}
          {completed && (
            <Tooltip title="Email Report">
              <span>
                <IconButton
                  aria-label="email report"
                  onClick={() => sendReport(row.id)}
                >
                  <EmailIcon />
                </IconButton>
              </span>
            </Tooltip>
          )}
          <Tooltip title="Email Package">
            <span>
              <IconButton
                aria-label="email package"
                onClick={() => sendPackage({ studyId: row.id, disableReport: !completed })}
              >
                <ForwardToInboxIcon />
              </IconButton>
            </span>
          </Tooltip>
          {hasTransfer && !claimed && (
            <Tooltip title="Transfer Study">
              <span>
                <IconButton
                  aria-label="transfer study"
                  onClick={() => transferStudy({ studyId: row.id, orgId: row.org && row.org.id })}
                >
                  <SwapHorizIcon />
                </IconButton>
              </span>
            </Tooltip>
          )}
          {access?.admin && (
            <Tooltip title="Admin Study Edit">
              <span>
                <IconButton
                  aria-label="edit study"
                  component={Link}
                  color="warning"
                  to={`/studies/${row.id}/consult/edit`}
                >
                  <ConstructionIcon />
                </IconButton>
              </span>
            </Tooltip>
          )}
        </>
      );
    }

    const hasTags = orgTags.length > 0

    const c = [{
      field: "actions",
      headerName: "Actions",
      headerAlign: "center",
      align: "center",
      minWidth: 12 * 40 + 20,
      fontWeight: 600,
      sortable: false,
      hideable: false,
      filterable: false,
      disableColumnSelector: true,
      pinned: 'left',
      renderCell: renderActionsCell,
    },
    {
      field: "priority",
      headerName: "Priority",
      headerAlign: "center",
      align: "center",
      fontWeight: 600,
      valueGetter: (value, row) => {
        if (row.priorityRef) return row.priorityRef.name || ''
        const pro = row.priority || 0
        return PRIORITIES.find(e => e.id === pro)?.name || ''
      },
    },
    {
      field: "sentAt",
      headerName: "Request Date",
      headerAlign: "center",
      align: "center",
      fontWeight: 600,
      minWidth: 150,
      type: "dateTime",
      valueGetter: (value, row) => row.sentAt && dayjs(row.sentAt).toDate(),
      renderCell: (params) => {
        const outputOptions = {
          year: "2-digit",
          month: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          timeZone: params.row.org?.timezone || 'America/Los_Angeles'
        }
        return (params.value && params.value.toLocaleString("en-US", outputOptions)) || ''
      }
    },
    {
      field: "associateOrg.name",
      headerName: "Requested By",
      headerAlign: "center",
      align: "center",
      minWidth: 250,
      fontWeight: 600,
      valueGetter: (value, row) => row.associateOrg?.name || row.sentBy?.org?.name || '',
    },
    {
      field: "userData.PatientMainDicomTags.PatientID",
      headerName: "Patient ID",
      headerAlign: "center",
      align: "center",
      fontWeight: 600,
      valueGetter: (value, row) => row.PatientMainDicomTags.PatientID,
    },
    {
      field: "userData.PatientMainDicomTags.PatientName",
      headerName: "Patient Name",
      headerAlign: "center",
      align: "center",
      fontWeight: 600,
      minWidth: 200,
      valueGetter: (value, row) => row.PatientMainDicomTags.PatientName,
    },
    {
      field: "userData.PatientMainDicomTags.ResponsiblePerson",
      headerName: "Owner Name",
      headerAlign: "center",
      align: "center",
      fontWeight: 600,
      minWidth: 200,
      valueGetter: (value, row) => row.PatientMainDicomTags.ResponsiblePerson,
    },
    {
      field: "userData.PatientMainDicomTags.PatientSpeciesDescription",
      headerName: "Species",
      headerAlign: "center",
      align: "center",
      fontWeight: 600,
      valueGetter: (value, row) => row.PatientMainDicomTags.PatientSpeciesDescription,
    },
    {
      field: "userData.PatientMainDicomTags.PatientBirthDate",
      headerName: "Age",
      headerAlign: "center",
      align: "center",
      fontWeight: 600,
      type: "dateTime",
      valueGetter: (value, row) => row.PatientMainDicomTags.PatientBirthDate && dayjs(row.PatientMainDicomTags.PatientBirthDate).toDate(),
      renderCell: (params) => (params.value && moment.duration(moment().diff(params.value)).humanize()) || ''
    },
    {
      field: "instanceCount",
      headerName: "Images",
      headerAlign: "center",
      align: "center",
      fontWeight: 600,
      sortable: true,
      filterable: true,
      valueGetter: (value, row) => row.instanceCount,
      renderCell: params => params.value + (params.row.media && params.row.media.length ? `+${params.row.media.length}` : '') + (params.row.numImages ? ` of ${params.row.numImages}` : '')
    },
    {
      field: "modalities",
      headerName: "Modality",
      headerAlign: "center",
      align: "center",
      filterable: true,
      sortable: true,
      fontWeight: 600,
      valueGetter: (value, row) => row.modalities?.join(', ') || '',
    },
    {
      field: "userData.MainDicomTags.StudyDescription",
      headerName: "Study Description",
      headerAlign: "center",
      align: "center",
      fontWeight: 600,
      minWidth: 200,
      valueGetter: (value, row) => row.MainDicomTags.StudyDescription,
    },
    {
      field: "claimBy.name",
      headerName: "Claimer",
      headerAlign: "center",
      align: "center",
      fontWeight: 600,
      minWidth: 250,
      valueGetter: (value, row) => {
        const claimerEmail = row.claimBy?.name || (row.requestee?.length && `[${row.requestee.map(e=>e.name).join(', ')}]`) || '';
        return claimerEmail;
      },
    },
    {
      field: "waitTime",
      headerName: "Wait Time",
      headerAlign: "center",
      align: "center",
      fontWeight: 600,
      type: "dateTime",
      filterable: false,
      sortable: false,
      valueGetter: (value, row) => row.sentAt && dayjs(row.sentAt).toDate(),
      renderCell: (params) => {
        if (!params.value)
          return ''
        const startime = (params.row.completeAt && moment(params.row.completeAt.last || params.row.completeAt.first)) || moment()
        return moment.duration(startime.diff(params.value)).humanize()
      }
    },
    ...(hasTags ? [{
      field: 'tags',
      headerName: 'Tags',
      headerAlign: 'center',
      align: 'center',
      fontWeight: 600,
      minWidth: 160,
      sortable: false,
      filterable: false,
      valueGetter: (value, row) => row.tags?.map(t => t.name).join(', ') || '',
      renderCell: params => {
        const tags = params.row.tags || []
        const availableTags = orgTags.filter(t => !tags.some(e => e.name === t))
        const canDelete = tag => access.admin || tag.view === view
        const updateTag = (action, name, tagView) => {
          UpdateStudyTags(params.row.id, { action, name, view: tagView || view }).then(result => {
            setStudies(s => s.map(r => r.id === params.row.id ? { ...r, tags: result.tags } : r))
          }).catch(e => e)
        }
        return (
          <TagCell
            tags={tags}
            availableTags={availableTags}
            canDelete={canDelete}
            onAdd={name => updateTag('add', name, view)}
            onDelete={tag => updateTag('remove', tag.name)}
          />
        )
      }
    }] : [])]
    return c.sort(columnSort)

  }, [columnSort, sendPackage, completeStudy, transferStudy, assignStudy, dicomSendStudy, user.id, access, hasTransfer, view, orgTags])

  const handleColumnOrderChange = useCallback(model => {
    setOrderedFields(Object.entries(model).sort((a, b) => a[1] - b[1]).map(([field]) => field))
  }, [])

  if (!initialState) {
    return <CircularProgress />;
  }

  return (
    <Paper style={{ height: 700, width: "100%" }}>
      <LocalizationProvider dateAdapter={AdapterDayjs}><Box>
        <TextField
          id="search"
          label="Search"
          type="text"
          variant="filled"
          fullWidth
          value={search.query || ''}
          onChange={(e) => setSearch(x => ({...x, query: e.target.value}))}
          InputProps={{
            endAdornment: (
              <>
                <InputAdornment position="end">
                  <IconButton onClick={(e) => openPopover(e, 'date')}>
                    <CalendarTodayIcon color={(search?.sentAt?.start || search?.sentAt?.end) ? 'primary' : 'inherit'} fontSize="small" />
                  </IconButton>
                </InputAdornment>
                <InputAdornment position="end">
                  <IconButton onClick={(e) => openPopover(e, 'org')}>
                    <BusinessIcon color={search?.associateOrg ? 'primary' : 'inherit'} fontSize="small" />
                  </IconButton>
                </InputAdornment>
                <InputAdornment position="end">
                  <IconButton onClick={(e) => openPopover(e, 'person')}>
                    <PersonIcon color={search?.claimBy ? 'primary' : 'inherit'} fontSize="small" />
                  </IconButton>
                </InputAdornment>
                {orgTags.length > 0 && (
                  <InputAdornment position="end">
                    <IconButton onClick={(e) => openPopover(e, 'tag')}>
                      <SellIcon color={search?.tags?.length ? 'primary' : 'inherit'} fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                )}
              </>
            ),
          }}
        />
        <Popover
          open={Boolean(popover?.anchor)}
          anchorEl={popover?.anchor}
          onClose={() => setPopover()}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Box p={2} minWidth={250}>
            {popover?.filter === 'date' && (
              <DateRangePicker
                value={[search.sentAt?.start, search.sentAt?.end]}
                onChange={(e) => {
                  const [start, end] = e || [null, null]
                  setSearch(x => ({...x, sentAt: {start, end}}))}
                }
                slotProps={{
                  textField: { size: "small", fullWidth: true },
                }}
              />
            )}

            {popover?.filter === 'org' && (
              <TextField
                select
                label="Requested By"
                value={search.associateOrg || ''}
                onChange={(e) => setSearch(x => ({...x, associateOrg: e.target.value}))}
                fullWidth
                size="small"
              >
                <MenuItem value="">&nbsp;</MenuItem>
                {orgs && orgs.map((org) => (
                  <MenuItem key={org.id} value={org.id}>
                    {org.name}
                  </MenuItem>
                ))}
              </TextField>
            )}

            {popover?.filter === 'person' && (
              <TextField
                select
                label="Claimer"
                value={search.claimBy || ''}
                onChange={(e) => setSearch(x => ({...x, claimBy: e.target.value}))}
                fullWidth
                size="small"
              >
                <MenuItem value="">&nbsp;</MenuItem>
                {users && users.map((user) => (
                  <MenuItem key={user.id} value={user.id}>
                    {user.name}
                  </MenuItem>
                ))}
              </TextField>
            )}
            {popover?.filter === 'tag' && (
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                {orgTags.map(t => (
                  <FormControlLabel
                    key={t}
                    label={t}
                    control={
                      <Checkbox
                        size="small"
                        checked={search?.tags?.includes(t) || false}
                        onChange={e => setSearch(x => {
                          const tags = x.tags ? [...x.tags] : []
                          e.target.checked ? tags.push(t) : tags.splice(tags.indexOf(t), 1)
                          return { ...x, tags: tags.length ? tags : undefined }
                        })}
                      />
                    }
                  />
                ))}
              </Box>
            )}
          </Box>
        </Popover>
      </Box></LocalizationProvider>
      <DataGrid
        columns={columns}
        rows={studies}
        pageSize={pageSize}
        sx={{ minWidth: 650 }}
        pageSizeOptions={[5, 10, 25, 50, 100]}
        loading={loading}
        filterMode="server"
        sortingMode={rowCount > pageSize ? 'server' : 'client'}
        paginationMode="server"
        onSortModelChange={onSortChange}
        onPaginationModelChange={onPageChange}
        disableColumnFilter={true}
        pagination={true}
        disableChildrenFiltering={true}
        disableChildrenSorting={true}
        disableAggregation={true}
        disableRowGrouping={true}
        rowCount={rowCount}
        apiRef={apiRef}
        initialState={initialState}
        onColumnOrderModelChange={handleColumnOrderChange}
        getDetailPanelContent={getDetailPanelContent}
      //rowBuffer={100} // Amount of rows allowed to be expanded before deleting old renders
      />
      <PdfPreview
        open={dialogState.open}
        studyId={dialogState.studyId}
        setDialogState={setDialogState}
      />
      <Confirmation
        open={deleteConfirmation.open}
        onCancel={deleteCancel}
        onConfirm={deleteConfirm}
        error={deleteConfirmation.error}
      >
        {deleteConfirmation.text}
      </Confirmation>
      <SendDialog dialogState={sendDialogState} />
      <TransferDialog dialogState={transferDialogState} user={user} />
      <AssignStudy dialogState={assignDialogState} access={access} />
      <DicomSend dialogState={dicomSendDialogState} user={user} />
    </Paper>
  )
}

export default Teleconsulations;